// Function to check and handle maximum activities
export const checkMaxActivities = () => {
  const activityItems = document.querySelectorAll('.js-evaluation-forms');
  const maxNotification = document.querySelectorAll(
    '.js-max-activity-notification'
  );
  const addButtons = document.querySelectorAll('.btn-add-activity');

  if (activityItems.length >= 10) {
    maxNotification.forEach(notification =>
      notification?.classList.remove('hidden')
    );

    // Disable all add buttons
    addButtons.forEach(btn => {
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      btn.classList.add('disabled');
    });
  } else {
    maxNotification.forEach(notification =>
      notification?.classList.add('hidden')
    );

    // Enable all add buttons
    addButtons.forEach(btn => {
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      btn.classList.remove('disabled');
    });
  }
};

// Call checkMaxActivities on page load
document.addEventListener('DOMContentLoaded', checkMaxActivities);
